import ProductControlsConnector from './productControls.props';
import ProductControlsComponent from './productControls.component';

export default ProductControlsConnector(ProductControlsComponent);
